import UserProfileContainer from "../../Componant/Users/UserProfile";

const UserProfile = () => {
  return (
    <div className="page-body">
      <UserProfileContainer />
    </div>
  );
};

export default UserProfile;
